module.exports = __webpack_public_path__ + "static/media/Ally_web_4.2dd45808.jpg";